import { useGetPatientTasksQuery } from "src/api/services/tasksApi";
import WhiteCard from "src/shared/components/WhiteCard";
import ActionItem from "./components/ActionItem";
import { useMemo } from "react";

const ActionItems = () => {
  const { data = [] } = useGetPatientTasksQuery();

  const tasks = useMemo(() => {
    const unpaidOrderTaskIndex = data.findIndex(
      (item) => item.task_type === "UNPAID_ORDER",
    );

    return data.filter(
      (item, idx) =>
        ![
          "UNPAID_ORDER",
          "RATE_ORDER",
          "RATE_EXPERIENCE",
          "DISCOUNT_OFFER",
          "WL_OPTIONS",
        ].includes(item.task_type) || idx === unpaidOrderTaskIndex,
    );
  }, [data]);

  if (tasks.length === 0) {
    return null;
  }

  return (
    <WhiteCard gap={2}>
      {tasks.map((task) => (
        <ActionItem item={task} key={task.id} />
      ))}
    </WhiteCard>
  );
};

export default ActionItems;
